import SubNav from "../../../SubNav/component";
import { EXTERNAL_LINKS } from "./constants";
import classNames from "classnames";

type ExternalNavProps = {
    path?: string;
    sectionName?: string;
};
/**
 * The ExternalNav component.
 *
 * This component renders the Menu list for the External Header that is used by 3rd parties, embedded via iframe onto their sites
 *
 */
export function ExternalNav({ path = "", sectionName = "" }: ExternalNavProps) {
    const externalNavProps = {
        path,
        items: [...EXTERNAL_LINKS],
        className: "externalSubNav",
    };

    const classes = classNames("externalNav", sectionName);

    return (
        <nav className={classes}>
            <SubNav {...externalNavProps} />
        </nav>
    );
}

export default ExternalNav;
